import * as React from "react";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import "./PriceInputSearchField.scss";
import { Box, Typography } from "@mui/material";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";

export default function PriceInputSearchField({
  value: propValue = "",
  onChange,
  onClick,
  label,
  maxLength = 13,
  ...props
}) {
  const [value, setValue] = React.useState(propValue);

  React.useEffect(() => {
    if (propValue !== value) {
      setValue(propValue);
    }
  }, [propValue]);

  const handleChange = (event) => {
    let inputValue = event.target.value;

    const decimalParts = inputValue.split(".");
    let integerPart = decimalParts[0];
    if (integerPart.length > 10) {
        integerPart = integerPart.substring(0, 10);
    }
    let decimalPart = decimalParts[1] || "";
    if (decimalPart.length > 2) {
        decimalPart = decimalPart.substring(0, 2);
    }
    inputValue = decimalParts.length > 1 ? `${integerPart}.${decimalPart}` : integerPart;

    // Allow only numbers and optional decimal point
    if (!/^\d*\.?\d*$/.test(inputValue)) return;

    if (inputValue.length > maxLength) return;
    setValue(inputValue);

    if (onChange) {
      onChange(inputValue);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (onClick) {
        onClick(value);
      }
    }
  };

  return (
    <div>
      <Paper component="form" variant="outlined" className="InputSearchFieldDimension"
       style={{
        border: (props.error !== undefined && props.error !== "") ? "1px solid #FE5050" : "1px solid #D9D9D9",
       }}
      >
      <InputBase
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        sx={{
          ml: 1,
          flex: 1,
          color: "#242424 !important",
          "& input": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block",
          },
          "&::placeholder": {
            color: "#242424 !important",
          },
        }}
        placeholder={label}
        className="input-placeholder"
        inputProps={{
          "aria-label": label,
          maxLength,
          inputMode: "decimal", // Helps on mobile keyboards
          pattern: "[0-9]*", // Ensures only numbers
        }}
      />
      <span className="PriceSymbol">$</span>
    </Paper>
    {(props.error !== undefined && props.error !== "") && (
        <Box display={"flex"} alignItems={"center"} pt={0.5}>
          <Box item pr={0.5} mt={0.5}>
            {<ErrorIcon />}
          </Box>
          <Box display="flex" alignItems="center">
            <Typography id="tags-error-message" className="helper-text">{props.error}</Typography>
          </Box>
        </Box>
      )}
    </div>
  );
}
